import { render, staticRenderFns } from "./AjudaTooltip.vue?vue&type=template&id=77253dc0&scoped=true&"
import script from "./AjudaTooltip.vue?vue&type=script&lang=js&"
export * from "./AjudaTooltip.vue?vue&type=script&lang=js&"
import style0 from "./AjudaTooltip.vue?vue&type=style&index=0&id=77253dc0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77253dc0",
  null
  
)

export default component.exports